import {
  disableBodyScroll,
  enableBodyScroll,
} from 'body-scroll-lock-upgrade';


class ModalStorage {
  constructor(element) {
    this.element = element
    this.init()
    this.oneWeekMS = 7 * 24 * 60 * 60 * 1000
    this.now = Date.now()
  }

  init() {
    this.modalId = this.element.getAttribute('data-modal-id')
    this.storageKey = `${this.modalId}-timestamp`

    const closedTimestamp = localStorage.getItem(this.storageKey)

    if (!closedTimestamp || (this.now - parseInt(closedTimestamp)) > this.oneWeekMS) {
      setTimeout(() => {
        this.element.showModal();
        [...this.element.querySelectorAll('.action')].map(action => {
          action.blur()
          return action
        })
        disableBodyScroll(this.element)
      }, 2500)
    }

    // Fallback for browsers without Invoker Commands (e.g. Safari < 26.2)
    const closeBtn = this.element.querySelector('.modal__close')
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.element.close()
      })
    }

    this.element.addEventListener('close', () => {
      localStorage.setItem(this.storageKey, this.now.toString())
      enableBodyScroll(this.element)
    });
  }
}
export default ModalStorage;
